import React, { useEffect, useState } from 'react';
import { DefaultCard } from '../../assets/styled-components/card';
import SectionTitle from '../commoncomponents/SectionTitle';
import { Checkbox, Collapse, FormControlLabel, List, ListItem, IconButton, Stack, Box } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import axios from 'axios';
import { ifacSecurityURL, MasterGraph } from '../../utility/apiURLS';
import { getAuthToken } from '../../utility/tokenUtility';
import CustomAutoMultiSelect from '../commoncomponents/CustomAutoMultiSelect copy';

const RegionFacility = ({
    isTypeChanged,
    setIsTypeChanged,
    setFacilities,
    roleNameOptions = [],
    companyCode,
    userData = [], isEdit = false,
    isView = false,
    isChanged,
    userType
}) => {
    const token = getAuthToken("id_token");
    const [departmentOptions, setDepartmentOptions] = useState([])

    function updateFacilities(allFacilities, selectedFacilities) {
        // Create a map of facilityId to the updated objects for quick lookup
        const updatedFacilitiesMap = new Map(
            selectedFacilities.flatMap(region => region.inner.map(facility => [facility.facilityId, facility]))
        );

        // Iterate through the original array to update matching facilities
        return allFacilities.map(region => {
            // Update the inner array
            const updatedInner = region.inner.map(facility =>
                updatedFacilitiesMap.get(facility.facilityId) || facility
            );

            // Check if all facilities in the updated inner array have checked === true
            const allChecked = updatedInner.every(facility => facility.checked);

            // Return the updated region with the checked property
            return { ...region, inner: updatedInner, checked: allChecked };
        });
    }


    const fetchOptions = async () => {
        try {
            const config = {
                headers: {
                    // Attach bearer token to request header
                    Authorization: `Bearer ${token}`,
                },
            };
            const departmentResponse = await axios.get(`${MasterGraph}/api/masuserdepartmentdetails?size=10000`, config)

            setDepartmentOptions(departmentResponse.data.map((department) => ({
                ...department,
                label: `${department?.departmentcode} - ${department?.departmentdesc}`,
                value: department?.departmentcode,
            })))
        }
        catch (error) {
            console.error("Error fetching service options:", error);
        }
    };

    function transformData(data) {
        // Create a map to group facilities by regionId
        const regionMap = {};

        // Iterate through each item in the data array
        data.forEach(item => {
            const { regionId, regionCode, regionName, facilityId, facilityCode, facilityName } = item;

            // If the regionId is not already in the map, add it
            if (!regionMap[regionId]) {
                regionMap[regionId] = {
                    label: `${regionCode} - ${regionName}`,
                    checked: false, // Default unchecked for outer region
                    expanded: false,
                    inner: [] // Initialize an empty inner array
                };
            }

            // Push the complete facility data into the inner array
            regionMap[regionId].inner.push({
                regionId,         // Include regionId
                regionCode,       // Include regionCode
                regionName,       // Include regionName
                facilityId,       // Include facilityId
                facilityCode,     // Include facilityCode
                facilityName,     // Include facilityName
                label: facilityName,
                checked: false    // Default unchecked for each facility
            });
        });

        // Convert the map values to an array
        return Object.values(regionMap);
    }

    function transformUserData(data) {
        // Create a map to group facilities by regionId
        const regionMap = {};

        // Iterate through each item in the data array
        data.forEach(item => {
            const {
                regionId, regionCode, regionName,
            } = item;

            // If regionId is not present, skip the item
            if (!regionId) {
                return;
            }

            // If the regionId is not already in the map, add it
            if (!regionMap[regionId]) {
                regionMap[regionId] = {
                    label: `${regionCode} - ${regionName}`,
                    checked: true, // Default unchecked for the outer region
                    expanded: false,
                    inner: [] // Initialize an empty inner array
                };
            }

            // Push the complete facility data into the inner array with all fields
            regionMap[regionId].inner.push({
                id: item.id,
                facilityId: item.facilityId,
                createdBy: item.createdBy || null, // Set to null if not provided
                modifiedBy: item.modifiedBy || null,
                isdeleted: item.isdeleted,
                userEmpNo: item.userEmpNo,
                staffStatusId: item.staffStatusId,
                userTypeId: item.userTypeId,
                department: departmentOptions.filter((opt) =>
                    item?.departmentId
                        ?.toLowerCase()
                        .split(",")
                        .includes(opt?.id?.toLowerCase())
                ),
                userId: item.userId,
                roleId: item.roleId,
                regionId: item.regionId,
                regionCode: item.regionCode,
                regionName: item.regionName,
                facilityCode: item.facilityCode,
                facilityName: item.facilityName,
                theme: item.theme,
                widgets: item.widgets,
                label: item.facilityName,
                checked: true // Set checked to true for each facility
            });
        });

        // Convert the map values to an array
        return Object.values(regionMap);
    }

    useEffect(() => {
        if (departmentOptions.length === 0) {
            fetchOptions()
        }
        if (isEdit || isView) {
            const selectedFacilities = transformUserData(userData)
            getFacilities(companyCode.id, selectedFacilities);

        } else if (companyCode?.id) {
            getFacilities(companyCode.id);
        } else {
            setItems([]);
        }
    }, [isEdit, isView, userData, companyCode]);

    const getFacilities = async (id, facilities = []) => {
        if (id)
            try {
                const config = {
                    headers: {
                        // Attach bearer token to request header
                        Authorization: `Bearer ${token}`,
                    },
                };
                const roleResponse = await axios.get(`${ifacSecurityURL}/api/GraphUserRegistration/GetSecregionListByCompanyId/${id}?size=1000`, config);
                if (isEdit || isView) {
                    setItems(updateFacilities(transformData(roleResponse.data), facilities))
                } else {
                    setItems(transformData(roleResponse.data))
                }
            }
            catch (error) {
                console.error("Error fetching service options:", error);
            }
    };

    const [items, setItems] = useState([]);

    // Handle changes in outer checkboxes
    const handleOuterChange = (index) => {
        if (isChanged) {
            isChanged();
        }
        if (isEdit) {
            const newItems = [...items];
            newItems[index].checked = !newItems[index].checked;
            newItems[index].inner = newItems[index].inner.map(item => ({
                ...item,
                checked: newItems[index].checked,
                isdeleted: !newItems[index].checked
            }));
            setItems(newItems);
        } else {
            const newItems = [...items];
            newItems[index].checked = !newItems[index].checked;
            newItems[index].inner = newItems[index].inner.map(item => ({
                ...item,
                checked: newItems[index].checked
            }));
            setItems(newItems);
        }
    };

    // Handle changes in inner checkboxes
    const handleInnerChange = (outerIndex, innerIndex) => {
        if (isChanged) {
            isChanged();
        }
        const newItems = [...items];
        if (newItems[outerIndex].inner[innerIndex].id) {
            newItems[outerIndex].inner[innerIndex].checked = !newItems[outerIndex].inner[innerIndex].checked;
            newItems[outerIndex].inner[innerIndex].isdeleted = !newItems[outerIndex].inner[innerIndex].isdeleted;
            newItems[outerIndex].checked = newItems[outerIndex].inner.every(item => item.checked);
            setItems(newItems);
        } else {
            newItems[outerIndex].inner[innerIndex].checked = !newItems[outerIndex].inner[innerIndex].checked;
            newItems[outerIndex].checked = newItems[outerIndex].inner.every(item => item.checked);
            setItems(newItems);
        }

    };

    // Handle expand/collapse toggle
    const toggleExpand = (index) => {
        const newItems = [...items];
        newItems[index].expanded = !newItems[index].expanded;
        setItems(newItems);
    };

    // New function to handle CustomSelectInput changes
    const handleRoleIdChange = (value, outerIndex, innerIndex,) => {
        setIsTypeChanged(false)
        const newItems = [...items];
        // Update the specific inner item with the roleId from the selected option
        newItems[outerIndex].inner[innerIndex].roleId = value?.roleId || null;
        setItems(newItems);
    };

    // New function to handle CustomSelectInput changes
    const handleDepartmentChange = (value, outerIndex, innerIndex,) => {
        setIsTypeChanged(false)
        const newItems = [...items];
        // Update the specific inner item with the roleId from the selected option
        newItems[outerIndex].inner[innerIndex].department = value || [];
        setItems(newItems);
    };

    useEffect(() => {
        if (isTypeChanged) {
            setItems((prev) => {
                return prev.map(region => ({
                    ...region,
                    inner: region.inner.map(facility => ({
                        ...facility,
                        roleId: null,
                    })),
                }));
            })
        }

    }, [isTypeChanged])

    useEffect(() => {
        // Create a new array to store facilities based on isEdit
        const checkedFacilities = [];

        items.forEach(outerItem => {
            outerItem.inner.forEach(innerItem => {
                if (innerItem.checked || innerItem.id) {
                    checkedFacilities.push(innerItem)
                }
            });
        });
        setFacilities(checkedFacilities);
    }, [items, isEdit, isTypeChanged]); // Dependency on items and isEdit


    return (
        <DefaultCard>
            <SectionTitle title="Region/Location" />
            <List sx={{ width: '100%' }}>
                {items.map((outerItem, outerIndex) => (
                    <div key={outerIndex} style={{ width: '100%' }}>
                        <ListItem sx={{ width: '100%' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled={isView}
                                        checked={outerItem.checked}
                                        onChange={() => handleOuterChange(outerIndex)}
                                    />
                                }
                                label={outerItem.label}
                            />
                            {/* Collapse/Expand icon */}
                            <IconButton onClick={() => toggleExpand(outerIndex)}>
                                {outerItem.expanded ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                        </ListItem>
                        {/* Collapsible inner list */}
                        <Collapse in={outerItem.expanded} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding sx={{ width: '100%' }}>
                                {outerItem.inner.map((innerItem, innerIndex) => (
                                    <ListItem key={innerIndex} style={{ paddingLeft: 40, width: '100%' }}>
                                        <Stack direction={"row"} spacing={2} sx={{ width: '100%' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        disabled={isView}
                                                        checked={innerItem.checked}
                                                        onChange={() => handleInnerChange(outerIndex, innerIndex)}
                                                    />
                                                }
                                                label={innerItem.label}
                                            />
                                            <Box sx={{ flexGrow: 1, maxWidth: 400 }}>
                                                <CustomSelectInput
                                                    disabled={isView}
                                                    options={roleNameOptions}
                                                    disableClearable={true}
                                                    value={roleNameOptions.find(option => option?.roleId === innerItem?.roleId)}
                                                    onChange={(e) => handleRoleIdChange(e, outerIndex, innerIndex)}
                                                    sx={{ width: '100%' }}  // Set full width for the select input
                                                    placeholder={"Please Select Role"}
                                                />
                                            </Box>
                                            {userType?.id === 3 && <Box sx={{ flexGrow: 1, maxWidth: 400 }}>
                                                <CustomAutoMultiSelect
                                                    disabled={isView}
                                                    label={""}
                                                    defaultValue={innerItem?.department || []}
                                                    options={departmentOptions.filter((facility) => facility?.facilityid === innerItem?.facilityId)}
                                                    onChange={(e) => handleDepartmentChange(e, outerIndex, innerIndex)}
                                                    placeholder='Please Select Department'
                                                />
                                            </Box>}
                                        </Stack>
                                    </ListItem>
                                ))}
                            </List>
                        </Collapse>
                    </div>
                ))}
            </List>
        </DefaultCard>
    );
};

export default RegionFacility;
